import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
import { debounce } from "@/utils/helpers";
import { RefreshCw } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";

export default function AutoSaveInput({
  className,
  initialValue = "",
  onSave,
  debounceMs = 300,
  ...props
}) {
  const [isSaving, setIsSaving] = useState(false);
  const [value, setValue] = useState(initialValue);
  const textareaRef = useRef(null);
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto"; // Reset height
      textarea.style.height = textarea.scrollHeight + "px"; // Set to content height
    }
  }, [value]); // Runs whenever the text changes
  // Create a memoized debounced save function
  const debouncedSave = useCallback(
    debounce(async (newValue) => {
      try {
        setIsSaving(true);
        await onSave(newValue);
      } catch (error) {
        console.error("Error saving:", error);
      } finally {
        setIsSaving(false);
      }
    }, debounceMs),
    [onSave, debounceMs]
  );
  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedSave(newValue);
  };
  return (
    <>
      <Textarea
        ref={textareaRef}
        value={value}
        onChange={handleChange}
        className={cn(
          "border-none text-lg my-0 focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0 resize-none",
          className
        )}
        {...props}
      />
      <RefreshCw
        className={`w-3 h-3 ${isSaving ? "animate-spin" : "hidden"}`}
      />
    </>
  );
}
